import styled from 'styled-components'
import KeywordItem from '@app.feature/exam/gsat2024-2/desktop/components/KeywordItem'
import useGetQuestionKeywords from '@app.feature/exam/gsat2024-2/hooks/useGetQuestionKeywords'
import useIsAdmin from 'hooks/useIsAdmin'

interface KeywordListMobileProps {
  questionId: string
}

const KeywordListMobile = ({ questionId }: KeywordListMobileProps) => {
  const isAdmin = useIsAdmin()
  const { keywords, ref } = useGetQuestionKeywords({ questionId: questionId })

  if (!keywords?.nodes.length) {
    return <StyledNullKeyword>등록된 키워드가 없습니다.</StyledNullKeyword>
  }

  return (
    <StyledWrapper>
      <div className="scroll-box">
        {keywords?.nodes?.map((keywordData) => {
          return (
            <KeywordItem
              id={keywordData.id}
              label={keywordData.keyword}
              isAdmin={isAdmin}
              key={keywordData.id}
            />
          )
        })}
        {keywords?.pageInfo.hasNextPage && (
          <div ref={ref} className="infinite-scroll-ref" />
        )}
      </div>
    </StyledWrapper>
  )
}

export default KeywordListMobile

const StyledNullKeyword = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: -0.72px;
  text-align: center;
`

const StyledWrapper = styled.div`
  overflow-y: scroll;
  max-height: 140px;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cccccc;
    border-radius: 100px;
  }

  > .scroll-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    column-gap: 8px;
    row-gap: 10px;

    > .infinite-scroll-ref {
      width: 100%;
      height: 1px;
    }
  }
`
